import { HttpContext } from "@angular/common/http";
import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";
import { pathParamsHelper } from "../helpers/path-params.helper";
import { SelectKeyValue } from "../models/select-key-value";
import { PiaContextService } from "../pia-api/pia-context.service";
import { IS_IN_RESOLVER_CONTEXT } from "../tokens/resolver-context.token";
import { withLoading } from "../utils/with-loading";

/**
 * used to get the select key/value lists for document languages based countryID and
 * with a flag for preselected item(s)
 * @param route
 */
export const productDocumentsLanguagesResolver: ResolveFn<
  Observable<{ primary: SelectKeyValue[]; secondary: SelectKeyValue[] }>
> = withLoading(
  (
    route: ActivatedRouteSnapshot,
  ): Observable<{ primary: SelectKeyValue[]; secondary: SelectKeyValue[] }> => {
    const piaContextService = inject(PiaContextService);
    const { countryID, languageID } = pathParamsHelper(route);
    const context = new HttpContext().set(IS_IN_RESOLVER_CONTEXT, true);

    if (!countryID) {
      return of({
        primary: [] as SelectKeyValue[],
        secondary: [] as SelectKeyValue[],
      });
    }

    return piaContextService
      .getDocumentLanguagesByCountryAndDefaultSelectedByLanguage(
        {
          countryID,
          languageID,
        },
        context,
      )
      .pipe(
        map((response) => response),
        catchError(() =>
          of({
            primary: [] as SelectKeyValue[],
            secondary: [] as SelectKeyValue[],
          }),
        ),
      );
  },
);
